export enum AssetFamily {
  Other = "Other",
  Trucks = "Trucks",
  "IT & TC" = "IT & TC",
  Generators = "Generators",
  "Light Vehicle" = "Light Vehicle",
}

export const ASSETS_FAMILY = Object.values(AssetFamily);
